// extracted by mini-css-extract-plugin
export default {"gnb":"MenuBar_gnb__c3EuU"};